<template>
    <div class="columns" style="margin-bottom: 75px;">
        <div class="column is-half-desktop">
            <year-range-slider />
            <km-range-slider />
            <transmissions />
            <chassis />
            <lot-numbers />
            <grades />
        </div>
        <div class="column is-half-desktop">
            <displacement-slider />
            <price-slider />
            <car-grade />
            <color-picker />
            <equipment />
        </div>
    </div>
</template>

<script>
    import YearSlider from './YearRangeSlider'
    import KmSlider from './KmRangeSlider'
    import Transmissions from './TransmissionsSpecification'
    import Chassis from './ChassisInput'
    import LotNumbers from './LotNumberInput'
    import Grades from './AuctionGrades'
    import PriceSlider from './PriceSlider'
    import DisplacementSlider from './DisplacementRangeSlider'
    import CarGrade from './CarGradeInput'
    import ColorPicker from './SpecificationColorPalette'
    import Equipment from './SpecificationEquipment'

    export default {
        components: {
            yearRangeSlider: YearSlider,
            kmRangeSlider: KmSlider,
            transmissions: Transmissions,
            chassis: Chassis,
            lotNumbers: LotNumbers,
            grades: Grades,
            priceSlider: PriceSlider,
            displacementSlider: DisplacementSlider,
            carGrade: CarGrade,
            colorPicker: ColorPicker,
            equipment: Equipment
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/SpecificationsFilter.vue